'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _resource = require('../resource');

var _resource2 = _interopRequireDefault(_resource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tickets = function (_Resource) {
    (0, _inherits3.default)(Tickets, _Resource);

    function Tickets() {
        (0, _classCallCheck3.default)(this, Tickets);
        return (0, _possibleConstructorReturn3.default)(this, (Tickets.__proto__ || (0, _getPrototypeOf2.default)(Tickets)).apply(this, arguments));
    }

    (0, _createClass3.default)(Tickets, [{
        key: 'searchForGroup',

        /**
         * @api {post} /v1/groups/:group_id/tickets/search searchForGroup
         * @apiGroup Tickets
         * @apiName searchForGroup
         * @apiDescription Get all tickets from the specified group that satisfy the search criteria, now we support field bundleAutoassign with
                           operator = and values true or false. Capable of returning paginated results.
         * @apiParam {Number} group_id
         * @apiParam {Object[]} query_params
         * @apiParam {Object} bounding_box
         * @apiParam {String} timezone
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.tickets.searchForGroup({...})
         */
        value: function searchForGroup(params) {
            var queryParams = this.stringForQueryObject(params.query_params);
            var data = {
                query: params.query,
                bounding_box: params.bounding_box,
                timezone: params.timezone
            };

            return this.client.post('/v1/groups/' + params.group_id + '/tickets/search' + queryParams, data);
        }

        /**
         * @api {get} /v1/tickets/my_list getAllForCurrentCustomer
         * @apiGroup Tickets
         * @apiName getAllForCurrentCustomer
         * @apiDescription Get all tickets that belong to current user's id.
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.tickets.getAllForCurrentCustomer({...})
         */

    }, {
        key: 'getAllForCurrentCustomer',
        value: function getAllForCurrentCustomer(params) {
            var query = params ? this.stringForQueryObject(params.query) : '';

            return this.client.get('/v1/tickets/my_list' + query);
        }

        /**
         * @api {get} /v1/customers/:customer_id/tickets getAllForCustomer
         * @apiGroup Tickets
         * @apiName getAllForCustomer
         * @apiDescription Get all tickets that belong to the given customer.
         * @apiParam {Number} customer_id
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.tickets.getAllForCustomer({...})
         */

    }, {
        key: 'getAllForCustomer',
        value: function getAllForCustomer(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.get('/v1/customers/' + params.customer_id + '/tickets' + query);
        }

        /**
         * @api {post} /v2/organizations/:organization_id/search/tickets searchForOrganization
         * @apiGroup Tickets
         * @apiName searchForOrganization
         * @apiDescription Search all tickets of an organization. Capable of returning paginated results.
         * @apiParam {Number} organization_id
         * @apiParam {String} query_string
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.tickets.searchForOrganization({...})
         */

    }, {
        key: 'searchForOrganization',
        value: function searchForOrganization(params) {
            var query = this.stringForQueryObject(params.query);
            var data = {
                query_string: params.query_string
            };

            return this.client.post('/v2/organizations/' + params.organization_id + '/search/tickets' + query, data);
        }

        /**
         * @api {post} /v2/organizations/:organization_id/search/tickets/filters searchWithFieldForOrganization
         * @apiGroup Tickets
         * @apiName searchWithFieldForOrganization
         * @apiDescription Search all tickets of an organization in the specified searchField. Capable of returning paginated results.
         * @apiParam {Number} organization_id
         * @apiParam {String} search_field
         * @apiParam {String} query_string
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.tickets.searchWithFieldForOrganization({...})
         */

    }, {
        key: 'searchWithFieldForOrganization',
        value: function searchWithFieldForOrganization(params) {
            var query = this.stringForQueryObject(params.query);
            var data = {
                search_field: params.search_field,
                query_string: params.query_string
            };

            return this.client.post('/v2/organizations/' + params.organization_id + '/search/tickets/filters' + query, data);
        }

        /**
         * @api {post} /v1/tickets/:ticket_id/data_items createDataItem
         * @apiGroup Tickets
         * @apiName createDataItem
         * @apiDescription Create a new data_item for the ticket.
         * @apiParam {Number} ticket_id
         * @apiParam {Object} data_item
         * @apiExample {js} Example:
         *             gigwalk.tickets.createDataItem({...})
         */

    }, {
        key: 'createDataItem',
        value: function createDataItem(params) {
            return this.client.post('/v1/tickets/' + params.ticket_id + '/data_items', (0, _extends3.default)({}, params.data_item));
        }

        /**
         * @api {delete} /v1/tickets/:ticket_id/data_items/:data_item_id deleteDataItem
         * @apiGroup Tickets
         * @apiName deleteDataItem
         * @apiDescription Delete the specified data_item from the specified ticket. This is a hard delete.
         * @apiParam {Number} ticket_id
         * @apiParam {Number} data_item_id
         * @apiExample {js} Example:
         *             gigwalk.tickets.deleteDataItem({...})
         */

    }, {
        key: 'deleteDataItem',
        value: function deleteDataItem(params) {
            return this.client.delete('/v1/tickets/' + params.ticket_id + '/data_items/' + params.data_item_id);
        }

        /**
         * @api {post} /v1/tickets/:ticket_id/clone clone
         * @apiGroup Tickets
         * @apiName clone
         * @apiDescription Create a new ticket by cloning the given ticket. This is a deep copy: metadata is copied as well. Ticket status will be UNASSIGNED.
         * @apiParam {Number} ticket_id
         * @apiExample {js} Example:
         *             gigwalk.tickets.clone({...})
         */

    }, {
        key: 'clone',
        value: function clone(params) {
            return this.client.post('/v1/tickets/' + params.ticket_id + '/clone');
        }

        /**
         * @api {post} /v1/tickets/:ticket_id/submit submit
         * @apiGroup Tickets
         * @apiName submit
         * @apiDescription Submit the given ticket. This is a terminal state for the ticket.
         * @apiParam {Number} ticket_id
         * @apiExample {js} Example:
         *             gigwalk.tickets.submit({...})
         */

    }, {
        key: 'submit',
        value: function submit(params) {
            return this.client.post('/v1/tickets/' + params.ticket_id + '/submit');
        }

        /**
         * @api {get} /v1/tickets/:ticket_id get
         * @apiGroup Tickets
         * @apiName get
         * @apiDescription Get ticket information. it returns information about the specified ticket.
         * @apiParam {Number} ticket_id
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.tickets.get({...})
         */

    }, {
        key: 'get',
        value: function get(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.get('/v1/tickets/' + params.ticket_id + query);
        }

        /**
         * @api {post} /v1/tickets/:ticket_id searchWithID
         * @apiGroup Tickets
         * @apiName searchWithID
         * @apiDescription You should use only /v1/tickets/search, other endpoints directed to the search method. Capable of returning paginated results.
         * @apiParam {Number} ticket_id
         * @apiParam {Object} search
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.tickets.searchWithID({...})
         */

    }, {
        key: 'searchWithID',
        value: function searchWithID(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.post('/v1/tickets/' + params.ticket_id + query, (0, _extends3.default)({}, params.search));
        }

        /**
         * @api {put} /v1/tickets/:ticket_id update
         * @apiGroup Tickets
         * @apiName update
         * @apiDescription Perform action on the corresponding ticket.
         * @apiParam {Number} ticket_id
         * @apiParam {String} [action='schedule']
         * @apiParam {String} customer_id
         * @apiExample {js} Example:
         *             gigwalk.tickets.update({...})
         */

    }, {
        key: 'update',
        value: function update(params) {
            var data = {
                action: params.action ? params.action : 'schedule',
                force: params.force || false,
                customer_id: params.customer_id,
                date_scheduled: params.date_scheduled,
                time_zone: params.time_zone
            };

            return this.client.put('/v1/tickets/' + params.ticket_id, data);
        }

        /**
         * @api {put} /v1/tickets update
         * @apiGroup Tickets
         * @apiName bulkUpdate
         * @apiDescription Edit tickets. Perform action on tickets with ticket_ids.
         * @apiParam {String} [action='schedule']
         * @apiParam {Number[]} ticket_ids
         * @apiParam {String} customer_id
         * @apiExample {js} Example:
         *             gigwalk.tickets.bulkUpdate({...})
         */

    }, {
        key: 'bulkUpdate',
        value: function bulkUpdate(params) {
            var data = {
                action: params.action ? params.action : 'schedule',
                force: params.force || false,
                ticket_ids: params.ticket_ids,
                customer_id: params.customer_id,
                date_scheduled: params.date_scheduled,
                time_zone: params.time_zone
            };

            return this.client.put('/v1/tickets', data);
        }

        /**
         * @api {get} /v1/tickets getAll
         * @apiGroup Tickets
         * @apiName getAll
         * @apiDescription Gets all tickets of the current user's organization.
         * @apiExample {js} Example:
         *             gigwalk.tickets.getAll({...})
         */

    }, {
        key: 'getAll',
        value: function getAll() {
            return this.client.get('/v1/tickets');
        }

        /**
         * @api {post} /v1/tickets search
         * @apiGroup Tickets
         * @apiName search
         * @apiDescription You should use only /v1/tickets/search, other endpoints directed to the search method. Capable of returning paginated results.
         * @apiParam {Object} search
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.tickets.search({...})
         */

    }, {
        key: 'search',
        value: function search(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.post('/v1/tickets' + query, (0, _extends3.default)({}, params.search));
        }

        /**
         * @api {put} /v1/tickets/:ticket_id/execution_state/:execution_state updateWithState
         * @apiGroup Tickets
         * @apiName updateWithState
         * @apiDescription Edit ticket(s). If ticket_id is present, assign the corresponding ticket. Otherwise, perform action to multiple tickets.
         * @apiParam {Number} ticket_id
         * @apiParam {String} execution_state
         * @apiParam {String} [action='schedule']
         * @apiParam {Number[]} ticket_ids
         * @apiParam {String} customer_id
         * @apiExample {js} Example:
         *             gigwalk.tickets.updateWithState({...})
         */

    }, {
        key: 'updateWithState',
        value: function updateWithState(params) {
            var data = {
                action: params.action ? params.action : 'schedule',
                ticket_ids: params.ticket_ids,
                customer_id: params.customer_id
            };

            return this.client.put('/v1/tickets/' + params.ticket_id + '/execution_state/' + params.execution_state, data);
        }

        /**
         * @api {get} /v1/organizations/:organization_id/tickets getAllForOrganization
         * @apiGroup Tickets
         * @apiName getAllForOrganization
         * @apiDescription Get information about all tickets of the organization. Capable of returning paginated results.
         * @apiParam {Number} organization_id
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.tickets.getAllForOrganization({...})
         */

    }, {
        key: 'getAllForOrganization',
        value: function getAllForOrganization(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.get('/v1/organizations/' + params.organization_id + '/tickets' + query);
        }

        /**
         * @api {post} /v1/organizations/:organization_id/tickets/search searchWithCriteriaForOrganization
         * @apiGroup Tickets
         * @apiName searchWithCriteriaForOrganization
         * @apiDescription Search tickets filtered by organization. Capable of returning paginated results.
         * @apiParam {Number} organization_id
         * @apiParam {Object} search
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.tickets.searchWithCriteriaForOrganization({...})
         */

    }, {
        key: 'searchWithCriteriaForOrganization',
        value: function searchWithCriteriaForOrganization(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.post('/v1/organizations/' + params.organization_id + '/tickets/search' + query, (0, _extends3.default)({}, params.search));
        }

        /**
         * @api {get} /v1/subscriptions/:subscription_id/tickets getAllForSubscription
         * @apiGroup Tickets
         * @apiName getAllForSubscription
         * @apiDescription Get information of all tickets in organizationSubscription (project). Capable of returning paginated results.
         * @apiParam {Number} subscription_id
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.tickets.getAllForSubscription({...})
         */

    }, {
        key: 'getAllForSubscription',
        value: function getAllForSubscription(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.get('/v1/subscriptions/' + params.subscription_id + '/tickets' + query);
        }

        /**
         * @api {post} /v1/subscriptions/:subscription_id/tickets/search searchForSubscription
         * @apiGroup Tickets
         * @apiName searchForSubscription
         * @apiDescription Search tickets filtered by the organizationSubscription (project). Capable of returning paginated results.
         * @apiParam {Number} subscription_id
         * @apiParam {Object} search
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.tickets.searchForSubscription({...})
         */

    }, {
        key: 'searchForSubscription',
        value: function searchForSubscription(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.post('/v1/subscriptions/' + params.subscription_id + '/tickets/search' + query, (0, _extends3.default)({}, params.search));
        }

        /**
         * @api {get} /v1/tickets/:ticket_id/events getEvents
         * @apiGroup Tickets
         * @apiName getEvents
         * @apiDescription Return events of ticket. Capable of returning paginated results.
         * @apiParam {Number} ticket_id
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.tickets.getEvents({...})
         */

    }, {
        key: 'getEvents',
        value: function getEvents(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.get('/v1/tickets/' + params.ticket_id + '/events' + query);
        }

        /**
         * @api {get} /v1/ticket_map getAllInArea
         * @apiGroup Tickets
         * @apiName getAllInArea
         * @apiDescription Return all applicable tickets within a radius of the specified location for a map display. Only nassigned tickets that fit the
                           certification criteria and are not yet due are returned.
         * @apiParam {Number} map_lat
         * @apiParam {Number} map_lon
         * @apiParam {Number} radius
         * @apiExample {js} Example:
         *             gigwalk.tickets.getAllInArea({...})
         */

    }, {
        key: 'getAllInArea',
        value: function getAllInArea(params) {
            var data = {
                map_lat: params.map_lat,
                map_lon: params.map_lon,
                radius: params.radius
            };

            return this.client.get('/v1/ticket_map', data);
        }
    }]);
    return Tickets;
}(_resource2.default);

exports.default = Tickets;
//# sourceMappingURL=index.js.map